import React from "react";
import { FormLabel, Input} from "@mui/joy";
import DOMPurify from "dompurify";

export function sanitizeHtml(html: string): string {
  if (!html) return html;
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'u', 'p', 'br', 'ul', 'ol', 'li', 'span', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'table', 'thead', 'tbody', 'tr', 'td', 'th', 'blockquote', 'hr', 'sub', 'sup'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style'],
  });
}

export function stripHtml(html: string): string {
  if (!html) return html;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
}

const mappers = [
  {
    propname: "isActive",
    map: (value: boolean) => (value === true ? "Actief" : "Inactief"),
  },
];


export function labelValue(value:string, label:string)

{
  return (
    <>
        <FormLabel >{label} </FormLabel>
        <Input
        disabled={true}
          sx={{
    '--Input-focusedThickness': '0.1rem',
    '--Input-focusedHighlight': 'var(--color-box-header-text)',
    backgroundColor: 'var(--color-input-bg) !important',
    color: 'var(--color-text) !important',
    borderColor: 'var(--color-box-border)',
    '&::before': {
      transition: 'box-shadow .15s ease-in-out',
    },
    '&:focus-within': {
      borderColor: 'var(--color-box-header-text)',
    },
    '&:focus-within::before': { boxShadow: 'var(--Input-focusedInset, inset) 0 0 0 calc(var(--Input-focused) * var(--Input-focusedThickness)) var(--color-box-header-text)' },
    '&.Mui-disabled': {
      backgroundColor: 'var(--color-input-bg) !important',
      color: 'var(--color-text) !important',
      opacity: 1,
    },
    '& .Mui-disabled, & input.Mui-disabled, & input:disabled': {
      color: 'var(--color-text) !important',
      WebkitTextFillColor: 'var(--color-text) !important',
      opacity: 1,
    }
  }} value={value ? value : ""}/>
    </>

  );
}

export function htmlLabelValue(html: string, label: string) {
  const sanitized = sanitizeHtml(html);
  const hasHtml = sanitized && /<[a-z][\s\S]*>/i.test(sanitized);

  if (!hasHtml) {
    return labelValue(html, label);
  }

  return (
    <>
      <FormLabel>{label}</FormLabel>
      <div
        dangerouslySetInnerHTML={{ __html: sanitized }}
        style={{
          padding: '8px 12px',
          border: '1px solid var(--color-box-border, #ccc)',
          borderRadius: 'var(--joy-radius-sm, 6px)',
          backgroundColor: 'var(--color-input-bg)',
          color: 'var(--color-text)',
          minHeight: '36px',
          fontSize: 'var(--joy-fontSize-sm, 0.875rem)',
          lineHeight: 'var(--joy-lineHeight-md, 1.5)',
          opacity: 1,
        }}
      />
    </>
  );
}

/**
 * @param milestone - The milestone object to retrieve the column value from.
 * @param column - The column object containing the property to retrieve from the milestone object.
 * @returns The value of the specified property in the milestone object, or an empty string if the property is undefined.
 */
export function getColumnValue(milestone: any, column: any) {
  if (!milestone || !column) return;
  const properties = column.property.split(".");
  let value = milestone;
  for (const property of properties) {
    if (property === "isActive" && typeof value[property] === "boolean") {
      value[property] = value[property] === true ? "Actief" : "Inactief";
    }
    if (property === "includeInMsTeam" && typeof value[property] === "boolean") {
      value[property] = value[property] === true ? "Ja" : "Nee";
    }
    value = value ? value[property] : undefined;
  }
  return value !== undefined ? value : "";
}
/**
 * Returns the value of a specific property of a milestone object.
 * @param milestone - The milestone object to retrieve the value from.
 * @param column - The column object containing the property to retrieve.
 * @returns The value of the specified property, or an empty string if it is undefined.
 */
export function getValue(milestone: any, column: any) {
  let value = milestone;
  value = value ? value[column.property] : undefined;
  return value !== undefined ? value : "";
}
export function formatDate(date: any) {
  if (typeof date === "string") {
    const dateRegex = /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}(\.[0-9]{1,3})?/i;
    const dateMatch = date.match(dateRegex);
    if (dateMatch) {

      const extractedDate = dateMatch[0];
      const dateObject = new Date(extractedDate);
      const formattedDate = dateObject.toLocaleDateString();
      return formattedDate;
    } else {
      return undefined;
    }

  }
  else return undefined;
}

export const convertToCurrencyLabel = (value: number): string => {
	if (value == null) { return ""; }
	return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value).replace(/\./g, ' ');
}
